import axios from 'axios';
import toast from 'react-hot-toast';

import * as cognito from 'lib/cognito';

async function getSession() {
  const session = await cognito.getSession();

  return session;
}

const fetch = () => {
  const defaultOptions = {
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
    headers: {
      'Content-type': 'application/json',
    },
  };

  const instance = axios.create(defaultOptions);

  instance.interceptors.request.use(async (config) => {
    await getSession()
      .then((res) => {
        window.localStorage.setItem('accessToken', `${res.accessToken.jwtToken}`);
        window.localStorage.setItem('refreshToken', `${res.refreshToken.token}`);
        window.localStorage.setItem('idToken', `${res.idToken.jwtToken}`);

        const token = localStorage.getItem('accessToken');

        config.headers!.Authorization = token ? `Bearer ${token}` : '';
      })
      .catch(() => {
        toast.error(
          'Sorry, we are not able to authorize, please refresh the page and try again'
        );
      });

    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      // The current backend's GlobalExceptionFilter responds with
      // {statusCode, message, error, timestamp} — `message` is a plain
      // string for most exceptions (e.g. ConflictException) but an ARRAY
      // of strings for class-validator's ValidationPipe errors. The old
      // `data.apierror.message` path was for the legacy Java backend and
      // never matches this shape, so every real error message was silently
      // swallowed in favor of a generic "Something went wrong" toast.
      const { message } = error?.response?.data || {};
      const errorMessage = Array.isArray(message) ? message.join(' ') : message;

      toast.error(errorMessage || 'Something went wrong');

      if (error?.response?.status === 403) {
        window.location.replace('/forbidden');
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export { fetch };
